import { render, staticRenderFns } from "./NoPermission.vue?vue&type=template&id=454b25a8"
import script from "./NoPermission.vue?vue&type=script&lang=ts"
export * from "./NoPermission.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports